import { useNavigate } from 'react-router-dom';
import { viewFactory } from '@/utils';

import { useMarketplaceMyFavouritesQuery, useRemoveFavouriteMarketplaceItemMutation } from './hooks';
import { MarketplaceMyFavouritesView } from './MarketplaceMyFavouritesView';

const MarketplaceMyFavouritesContainer = () => {
    const navigate = useNavigate();
    const query = useMarketplaceMyFavouritesQuery();
    const [removeFavouriteMarketplaceItem] = useRemoveFavouriteMarketplaceItemMutation();

    return viewFactory(MarketplaceMyFavouritesView, query, {
        onBack: () => navigate('/marketplace'),
        onRemoveFavourite: (id) =>
            removeFavouriteMarketplaceItem({
                variables: { id },
            }),
    });
};

export { MarketplaceMyFavouritesContainer };
